import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { FaInstagram, FaVk, FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => {
    api.get('/settings/public').then((r) => setS(r.data)).catch(() => {});
  }, []);
  const phone = (s.whatsapp_phone || '+918958956564').replace(/[^+\d]/g, '');
  const phoneDisplay = phone.replace(/^(\+\d{2})(\d{4})(\d{3})(\d{3}).*$/, '$1 $2 $3 $4');
  const waLink = `https://wa.me/${phone.replace('+', '')}`;
  const tgLink = `https://t.me/${(s.telegram_username || '+918958956564').replace(/^\+/, '')}`;

  return (
    <footer className="border-t border-border/60 mt-32">
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="overline mb-6">Ali · India · Tours</p>
            <h4 className="font-serif-display text-4xl md:text-5xl leading-none">
              Настоящая Индия.<br />Ваш проводник — <em className="text-saffron">Али</em>.
            </h4>
            <p className="mt-6 text-foreground/70 max-w-md">
              Русскоговорящий гид, живущий в Индии более 12 лет. Индивидуальные и групповые программы по Северной Индии.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-4">Контакты</p>
            <ul className="space-y-3 text-foreground/80">
              <li><a className="hover-underline" href={waLink} target="_blank" rel="noopener noreferrer">WhatsApp · {phoneDisplay}</a></li>
              <li><a className="hover-underline" href={tgLink} target="_blank" rel="noopener noreferrer">Telegram · {phoneDisplay}</a></li>
              <li><a className="hover-underline" href={`mailto:${s.email || 'haiderali89589@gmail.com'}`}>{s.email || 'haiderali89589@gmail.com'}</a></li>
            </ul>
            <div className="flex items-center gap-5 mt-6 text-xl text-foreground/80">
              <a href={waLink} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="hover:text-saffron"><FaWhatsapp /></a>
              <a href={tgLink} target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="hover:text-saffron"><FaTelegramPlane /></a>
              {s.instagram_url && <a href={s.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-saffron"><FaInstagram /></a>}
              {s.vk_url && <a href={s.vk_url} target="_blank" rel="noopener noreferrer" aria-label="VK" className="hover:text-saffron"><FaVk /></a>}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Навигация</p>
            <ul className="space-y-3 text-foreground/80">
              <li><a href="/#festival" className="hover-underline">Праздничные туры</a></li>
              <li><a href="/#weekly" className="hover-underline">Еженедельные туры</a></li>
              <li><a href="/#girls" className="hover-underline">Тур на 8 марта</a></li>
              <li><a href="/#about-ali" className="hover-underline">О гиде Али</a></li>
              <li><Link to="/admin/login" className="hover-underline text-foreground/50" data-testid="footer-admin-link">Панель управления</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-foreground/50 uppercase tracking-widest2">
          <span>© {new Date().getFullYear()} Ali India Tours · Все права защищены</span>
          <span>Сделано с любовью к Индии</span>
        </div>
      </div>
    </footer>
  );
}
